import Notifications from './Notifications.vue'

const NotificationStore = {
	state: [], // here the notifications will be added

	removeNotification() {
		this.state.pop();
	},
	notify(notification) {
		this.state.push(notification)
	}
}

var NotificationsPlugin = {

	install(Vue) {

		Vue.prototype.$notification = NotificationStore
		Vue.component('Notifications', Notifications)
	}
}

export default NotificationsPlugin



// WEBPACK FOOTER //
// ./src/components/NotificationPlugin/index.js